import { useEffect, useState } from 'react'
import { useUser } from './hooks/useUser'
import { useNavigate } from 'react-router-dom'

interface AdminRouteProps {
    children: React.ReactNode
}

// Redirects non-admin users to the /dashboard, effectively
// serving as a frontend gate for admin-only pages.
export const AdminRoute = ({ children }: AdminRouteProps) => {
    const { user } = useUser()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (user) {
            setLoading(false)
            if (!user?.is_admin) {
                navigate('/dashboard')
            }
        }
    }, [user])

    if (loading || !user?.is_admin) {
        return null
    }

    return children
}
